import React, { Fragment, useState, useEffect } from "react";
import { ReactSession } from "react-client-session";
import { Typography, TextField, Button, Box, Grid } from "@material-ui/core";
import Breadcrumb from "../Breadcrumb";
import { useHistory, useLocation } from "react-router-dom";
//theme
import { useStyles } from "../Theme.js";
//import { fetchInsertOnservation } from "../ConnexionTools.js";
const Connexion = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [login, setLogin] = useState("");
  const [mdp, setMdp] = useState("");
  const [retour, setRetour] = useState("");
  //const [etape, setEtape] = useState(0);
  const classes = useStyles();

  const loginconnect = ReactSession.get("login");
  /**
   * @async
   * @function fetchLogin
   * @return {void}
   */

  useEffect(() => {
    let user_id = ReactSession.get("user_id");
    if (user_id && typeof location.state !== "undefined") {
      //setRetour(
      fetchInsertOnservation(
        user_id,
        location.state.theme,
        location.state.id_observation
        //)
      );
    } else {
      if (user_id && typeof props.state !== "undefined") {
        //setRetour(
        fetchInsertOnservation(
          user_id,
          props.state.theme,
          props.state.id_observation
          //)
        );
      }
    }
  });
  function handleclick() {
    ReactSession.remove("login");
    ReactSession.remove("user_id");
    history.push("/");
  }
  async function fetchInsertOnservation(user_id, theme, id_observation) {
    try {
      console.log(user_id, theme, id_observation);
      const tabuserobservation = {
        id_observation: id_observation,
        theme: theme,
        id_user: user_id,
      };
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tabuserobservation),
      };
      const response = await fetch(
        window.location.protocol +
          "//" +
          window.location.hostname +
          "/natturapi/users/observation",
        requestOptions
      );
      if (response.status === 200) {
        return "Obervation créée";
      } else {
        return "Problème lors de la création";
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function fetchLogin() {
    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ login: login, mdp: mdp }),
      };
      const response = await fetch(
        window.location.protocol +
          "//" +
          window.location.hostname +
          "/natturapi/users/login",
        requestOptions
      );
      const user_id = await response.json();
      if (response.status === 200) {
        if (typeof location.state !== "undefined") {
          //setRetour(
          fetchInsertOnservation(
            user_id,
            location.state.theme,
            location.state.id_observation
            // )
          );
          alert(
            "Merci d'avoir pris le temps de répondre, vous allez être redirigé à l'accueil pour effectuer une nouvelle observation."
          );
          ReactSession.set("login", login);
          ReactSession.set("user_id", user_id);
        } else {
          alert(
            "Vous êtes connecté, vous allez être redirigé à l'accueil et commencer une observation"
          );
          ReactSession.set("login", login);
          ReactSession.set("user_id", user_id);
        }
        history.push("/");
      } else {
        setRetour("Connexion refusée : mot de passe ou login invalides");
      }
    } catch (err) {
      console.log(err);
    }
  }

  if (loginconnect) {
    return (
      <Fragment>
        <Breadcrumb size={8} current={0} />
        <Box className={classes.subHeader}>
          <Typography variant="h3" className={classes.subHeaderTitle}>
            Bonjour, {loginconnect} Vous êtes connecté
          </Typography>
          <Typography variant="body1" style={{ fontSize: 12 }}>
            {retour}
          </Typography>
        </Box>
        <Grid
          container
          style={{
            maxWidth: "100%",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            className={classes.navButton2}
            style={{
              marginTop: 20,
              fontSize: 15,
              BackgroundColor: "grey",
              fontWeight: "bold",
            }}
            onClick={() => handleclick()}
          >
            Déconnexion
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.navButton2}
            style={{
              marginTop: 20,
              fontSize: 15,
              BackgroundColor: "#e50039",
              fontWeight: "bold",
            }}
            onClick={() => history.push("/")}
          >
            Retour à l'accueil
          </Button>
        </Grid>
      </Fragment>
    );
  } else {
    if (location.pathname === "/user") {
      return (
        <Fragment>
          <style>{".suivantprecedent{display:none;}"}</style>
          <Breadcrumb size={8} current={0} />
          <Box className={classes.subHeader}>
            <Typography variant="h3" className={classes.subHeaderTitle}>
              Connexion
            </Typography>
            <Typography variant="body1" style={{ fontSize: 12 }}>
              {retour}
            </Typography>
          </Box>

          <Grid
            container
            style={{
              maxWidth: "100%",
              paddingLeft: "30px",
              paddingRight: "30px",
            }}
          >
            <form noValidate autoComplete="off" style={{ width: "100%" }}>
              <TextField
                label="identifiant"
                style={{ width: "100%" }}
                onChange={(event) => setLogin(event.target.value)}
                required
              />
              <TextField
                label="mot de passe"
                style={{ width: "100%" }}
                onChange={(event) => setMdp(event.target.value)}
                required
                type="password"
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.navButton2}
                style={{
                  marginTop: 20,
                  fontSize: 15,
                  BackgroundColor: "#e50039",
                  fontWeight: "bold",
                }}
                onClick={() => fetchLogin()}
              >
                Connexion
              </Button>
            </form>
          </Grid>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <style>{".suivantprecedent{display:none;}"}</style>
          <Grid
            container
            style={{
              maxWidth: "100%",
              paddingLeft: "30px",
              paddingRight: "30px",
            }}
          >
            <form noValidate autoComplete="off" style={{ width: "100%" }}>
              <TextField
                label="identifiant"
                style={{ width: "100%" }}
                onChange={(event) => setLogin(event.target.value)}
                required
              />
              <TextField
                label="mot de passe"
                style={{ width: "100%" }}
                onChange={(event) => setMdp(event.target.value)}
                required
                type="password"
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.navButton2}
                style={{
                  marginTop: 20,
                  fontSize: 15,
                  BackgroundColor: "#e50039",
                  fontWeight: "bold",
                }}
                onClick={() => fetchLogin()}
              >
                Connexion
              </Button>
            </form>
          </Grid>
        </Fragment>
      );
    }
  }
};

export default Connexion;
